import React, { useState } from "react";
import {
  Button,
  Box,
} from "@mui/material";
import { TypeField } from "src/components/content-builder";
import { useForm } from "react-hook-form";

interface ComponentFormProps {
  component: any;
  initialData: any;
  onSave: (data: any) => void;
  onClose: () => void;
}

export const ComponentForm: React.FC<ComponentFormProps> = (props) => {
  const { component, initialData, onSave, onClose } = props;

  const { trigger, register, getValues, setValue, formState: { errors }} = useForm({
    defaultValues: initialData,
  });

  const handleSave = () => {
    trigger().then(validated => {
      if (validated) {
        onSave(getValues());    
      }
    });
  };

  return (
    <Box className="component-form">
      <Box
        display="flex"
        flexDirection="column"
        gap="1em"
      >
        {component.fields.map((field, index) => (
          <TypeField 
            key={index}
            type={field?.type} 
            required={field?.required ?? false}
            name={field.name} 
            label={field.label} 
            additional={field.additional}
            options={field?.options ?? false} 
            data={getValues()}
            defaultValue={field?.defaultValue ?? ''} 
            error={!!errors[field.name]}
            helperText={(errors[field.name] as any)?.message}
            {...register(field.name, {
              required: field?.required ? "Field is required" : false
            })}
            onChange={(value, field) => setValue(field, value, { shouldValidate: true })}
          />
        ))}
      </Box>
      <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
        <Button variant="contained" color="primary" onClick={() => handleSave()}>
          {initialData ? "Update" : "Save"}
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </Box>
    </Box>
  );
};
